import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import {
  GetPromotionalBannerDetailParams,
  GetPromotionalBannerListParams,
  PromotionalBanner,
} from './promotionalBanner.types';

const getPromotionalBannerList = (client: AxiosInstance) => async (params: GetPromotionalBannerListParams) => {
  return (
    await client.get<PaginatedApiResponse<PromotionalBanner[]>>(API_ROUTES.GET_PROMOTIONAL_BANNER_LIST, { params })
  ).data;
};

const getPromotionalBannerDetails = (client: AxiosInstance) => async (params: GetPromotionalBannerDetailParams) => {
  return (await client.get<ApiResponse<PromotionalBanner>>(API_ROUTES.GET_PROMOTIONAL_BANNER_DETAIL, { params })).data;
};

export const promotionalBannerQueries = {
  all: () => ['promotional-banner'],
  list: (params: GetPromotionalBannerListParams) =>
    queryFactoryOptions<PaginatedApiResponse<PromotionalBanner[]>>({
      queryKey: [...promotionalBannerQueries.all(), 'list', params],
      queryFn: (client) => () => getPromotionalBannerList(client)(params),
    }),
  detail: (params: GetPromotionalBannerDetailParams) =>
    queryFactoryOptions<ApiResponse<PromotionalBanner>>({
      queryKey: [...promotionalBannerQueries.all(), 'detail', params],
      queryFn: (client) => () => getPromotionalBannerDetails(client)(params),
    }),
};
